import { useContext } from 'react';
import GeneralContext from '../../../context/GeneralContext';

const ErrorLogic = () => {
  const { lan, setGeneralValues } = useContext(GeneralContext);
  return { lan, setGeneralValues };
};
export default ErrorLogic;
